import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { delay, from, map, of, switchMap } from 'rxjs';
import { MissionCreationResult } from '../components/new-mission/new-mission.component';
import { Moment } from 'moment';
import { environment } from 'src/environments/environment';
import { getCurrentUser } from '@aws-amplify/auth';

@Injectable({
  providedIn: 'root',
})
export class MissionService {
  private http = inject(HttpClient);

  createMission(constructionProjectId: string, time: Moment) {
    return this.http
      .post<{
        data: {
          _id: string;
          storage_path: string;
        };
      }>(`${environment.apiUrl}/mission/create/`, {
        construction_project_id: constructionProjectId,
        flight_end_time: time.clone().utc().format(),
      })
      .pipe(map((response) => response.data));
  }

  startMissionProcessing(
    missionCreationResult: MissionCreationResult,
    s3Path?: string
  ) {
    return this.http.post<void>(
      `${environment.apiUrl}/mission/start_processing/`,
      {
        mission_id: missionCreationResult.missionId,
        external_photos_s3_folder_paths: s3Path ? [s3Path] : [],
      }
    );
  }
}
